import Input from "@material-ui/core/Input";
import { DataTypeProvider } from "@devexpress/dx-react-grid";
import TextField from "@material-ui/core/TextField";

const DateTimeFormatter = ({ value }) => OnlyDateTime(value);

const DateTimeEditor = ({ value, onValueChange, disabled }) => {
  if (disabled) {
    return value ? DateTimeFormatter({ value }) : "";
  }

  let dateField = "";
  if (value) {
    dateField = OnlyDateTime(value);
  }
  return (
    <TextField
      input={<Input />}
      id="date"
      type="date"
      defaultValue={dateField}
      onChange={(event) => onValueChange(event.target.value)}
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
};

const OnlyDateTime = (value) => {
  var newValue = "";
  if (value) {
    var apiDate = new Date(value);
    newValue = apiDate?.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  }
  return newValue;
};

export const DateTimeTypeProvider = (props) => <DataTypeProvider formatterComponent={DateTimeFormatter} editorComponent={DateTimeEditor} {...props} />;
